export const SCOPES = "https://www.googleapis.com/auth/userinfo.profile"